import { LeadFormData } from "components/DefaultSubscribeForm/types";
import { isSSR } from "../ssr";
import { digestSHA256 } from "../sha256";
import { WSPR } from "types/window";
import { LeadApiResponse } from "@silversea-ssc/dotcom-api-types/Lead";
import { WebQuoteFormData } from "components/WebQuoteModal/WebQuoteForm/WebQuoteForm";

type LeadFormDataWithPII = LeadFormData & {
  NameFirst_hash: string | undefined;
  NameLast_hash: string | undefined;
  Email_hash: string | undefined;
  Phone_hash: string | undefined;
};

export function getVisitorAuid(): string {
  try {
    if (!isSSR() && typeof window.get_auid !== "undefined")
      return window.get_auid();
    return "";
  } catch {
    return "";
  }
}

export function getMarketingCloudVisitorID(): string {
  try {
    if (
      !isSSR() &&
      window?._satellite &&
      typeof window._satellite.getVisitorId === "function"
    )
      return window?._satellite.getVisitorId()?.getMarketingCloudVisitorID();
    return "";
  } catch {
    return "";
  }
}

export async function trackFormSubmitted(
  event: FormTrackingEvent,
  data: LeadFormData,
  wspr?: WSPR
): Promise<void> {
  const eventWithHashedPII = {
    ...event,
    ...(await formEventWithHashedPII(data))
  };

  (wspr || window.wspr)?.P("web_request_submitted_raw", eventWithHashedPII);
  // dispatchTrackingEvent("web-request-submitted", event);
}

export async function trackWebQuoteFormSubmitted(
  event: FormTrackingEvent,
  data: WebQuoteFormData,
  wspr?: WSPR
): Promise<void> {
  const eventWithHashedPII = {
    ...event,
    ...(await webQuoteFormEventWithHashedPII(data))
  };

  (wspr || window.wspr)?.P("web_request_submitted_raw", eventWithHashedPII);
  // dispatchTrackingEvent("web-request-submitted", event);
}

const formEventWithHashedPII = async (
  data: LeadFormData
): Promise<LeadFormDataWithPII> => {
  return {
    NameFirst_hash: await digestSHA256(data.NameFirst),
    NameLast_hash: await digestSHA256(data.NameLast),
    Email_hash: await digestSHA256(data.Email),
    Phone_hash: await digestSHA256(data.Phone)
  };
};

const webQuoteFormEventWithHashedPII = async (
  data: WebQuoteFormData
): Promise<LeadFormDataWithPII> => {
  return {
    NameFirst_hash: await digestSHA256(data.firstName),
    NameLast_hash: await digestSHA256(data.lastName),
    Email_hash: await digestSHA256(data.email),
    Phone_hash: await digestSHA256(data.phoneNumber)
  };
};

export function trackCrossLeadFormSubmitted(event: FormTrackingEvent): void {
  window.wspr?.P("web_request_cross_lead_submitted_raw", event);
}

export type FormTrackingEvent = LeadApiResponse & {
  // wrid: number | undefined;
  // uwrid: string;
  // request_type?: FormRequestType;
  // brochure?: string;
  // is_agent?: boolean;
  // is_test?: boolean;
  formName: string;
  phone_number_is_present?: boolean;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function pushToDataLayer(vals: any): void {
  if (!isSSR()) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(vals);
  }
}

export interface VoyageToDataLayerInterface {
  name?: string;
  code?: string;
  departure_date?: string;
  arrival_date?: string;
  days_duration?: number;
  ship_name?: string;
  price?: number;
  sale_state?: string;
  suite?: string;
  departure_port?: string;
  arrival_port?: string;
  destination_id?: number;
  destination_name?: string;
  cruise_type?: string;
}
export function voyageToDataLayer(args: VoyageToDataLayerInterface): void {
  pushToDataLayer(voyageToTrackingEvent(args));
}

export const voyageToTrackingEvent = (args: VoyageToDataLayerInterface) => {
  const { sale_state, ...commonArgs } = args;
  return {
    voyage_details: {
      sale_state: sale_state == "price" ? "active" : sale_state,
      ...commonArgs
    }
  };
};

interface DestinationToDataLayerInterface {
  name?: string;
  destination_id?: number;
  destination_type: "Classic" | "Expedition";
}
export function destinationToDataLayer(
  args: DestinationToDataLayerInterface
): void {
  const { name, destination_id, destination_type } = args;
  pushToDataLayer({
    destination_details: {
      name,
      destination_id,
      destination_type
    }
  });
}
